<template>
  <e-card @toggleDrag="$emit('toggleDrag')" :class="sizeClasses" class="buy-list-wizard" data-v-step="7">
    <b-tab title="Buy Crypto" class="e-card__content">
      <div class="trading-list">
        <transition name="fade">
          <b-table responsive v-if="!isLoading" hover class="e-table e-table--bg--white e-table--padding--small" :fields="currenciesListFields" :items="currenciesList" key="table">
            <template slot="HEAD_currency" slot-scope="data">
              Currencies
            </template>
            <template slot="HEAD_price" slot-scope="data">
              Rate
            </template>
            <template slot="HEAD_rate" slot-scope="data">
              Score
            </template>
            <template slot="HEAD_emixtier" slot-scope="data">
              Emixtier
            </template>
            <template slot="HEAD_actions" slot-scope="data"></template>
            <template slot="currency" slot-scope="data">
              <div class="d-flex align-items-center">
                <div class="e-avatar size-30 mr-4">
                  <img :src="data.item.logoPath">
                </div>
                <div class="d-flex flex-column">
                  <b>{{ data.item.name }}</b>
                  <span>{{ data.item.symbol }}</span>
                </div>
              </div>
            </template>
            <template slot="price" slot-scope="data">
              <b class="price">{{ data.item.price.value | formatPrice }} USD</b>
            </template>
            <template slot="rate" slot-scope="data">
              <p class="text-center">{{ data.item.rate === 0 ? 'N/A' : data.item.rate }}</p>
            </template>
            <template slot="emixtier" slot-scope="data">
              <p class="text-center">{{ data.item.rate === 0 ? 'N/A' : convertRate(data.item.rate) }}</p>
            </template>
            <template slot="actions" slot-scope="data">
              <div class="d-flex flex-row justify-content-end">
                <div class="form-group" style="margin-right: 10px">
                  <input type="text" class="tc-amount" :class="{ active: buyAmount[data.index] > 0 }" v-model="buyAmount[data.index]" @input="buyAmount[data.index] = $event.target.value != '' ? $event.target.value : 0"
                    value="0">
                  <div class="fg-amount-name">USD</div>

                  <!-- <transition name="fade">
                    <div class="result-volume" v-if="amount > 0">
                      ~ {{ computeResult.toFixed(4) }} <b>{{ coin.symbol }}</b>
                    </div>
                  </transition> -->
                </div>
                <e-button color="blue-light" size="small" :shadow="false" :disabled="buyAmount[data.index] === 0" @click="buyCurrency(data.index)">Buy</e-button>
              </div>
            </template>
          </b-table>
        </transition>
        
      </div>
      <button class='e-btn see-all' @click="onSeeAllClick()">See All Coins</button>
    </b-tab>
    <b-tab title="Buy Stock (Soon)" disabled class="e-card__content">
    </b-tab>
  </e-card>
</template>

<script>
  import DynamicSizeMixin from '../../../mixins/dynamicSize';
  import _ from 'lodash';
  import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
  import Services from '@services';
  import {convertRateToEmixtier} from "@utils/assets";

  const COLORS = {
    crypto: 'green',
    ico: 'lime-green',
    stock: 'blue',
    ipo: 'cyan',
    startup: 'violet',
  };

  export default {
		name: "ec-buy-list",
    mixins: [DynamicSizeMixin],
    filters: {
      formatPrice(price) {
        price = parseFloat(price);
        if(price <= 10) {
          return price.toFixed(6);
        } else if(price <= 50) {
          return price.toFixed(4);          
        }

        return price.toFixed(2)        
      },
    },
    data() {
      return {
        isLoading: true,
        currenciesList: [],
        buyAmount: [],
        currenciesListFields: [
          'currency', 'price', 'rate', 'emixtier', 'actions'
        ],
      };
    },
    methods: {
      ...mapActions('orders', ['createOrder']),
      ...mapMutations('orders', ['setShowBuyModal', 'setBuyModalData']),
      convertRate(rate) {
        return convertRateToEmixtier(rate);
      },
      async buyCurrency(index) {
        const asset = this.currenciesList[index];
        this.setBuyModalData({ asset: asset, amount: this.buyAmount[index], currency: 'USD'});
        this.setShowBuyModal(true);
      },
      onSeeAllClick() {
        this.$router.push({name: 'trading-buy'})
      }
    },
    computed: {
      maxAmount() {
        return 5000;
      }
    },
    async mounted() {
      this.isLoading = true;
      this.currenciesList = (await Services.Coins.fetchTradingAssets('crypto')).slice(0, 5);

      this.buyAmount = this.currenciesList.map(i => {
        return 0;
      })

      this.isLoading = false;
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/cards/buyList/buyList.vue